import { Box, Drawer, Toolbar, styled } from "@mui/material";
import { JSX, PropsWithChildren } from "react";

import type { DrawerProps as MUIDrawerProps, Theme } from "@mui/material";

type DrawerProps = {
  size?: "sm" | "md" | "lg";
};
type DrawerCustomProps = PropsWithChildren<MUIDrawerProps & DrawerProps>;

export const drawerSizeMap = {
  sm: 400,
  md: 600,
  lg: 800,
} as const;

const DrawerNavBar = styled(Toolbar, {
  shouldForwardProp: (prop) => prop !== "bottom",
})<{ bottom?: boolean }>(
  ({ theme, bottom = false }: { theme: Theme; bottom?: boolean }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    borderBottom: !bottom ? `1px solid ${theme.palette.divider}` : "none",
    borderTop: bottom ? `1px solid ${theme.palette.divider}` : "none",
    [theme.breakpoints.up("xs")]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  }),
);

const DrawerContent = styled(Box)(({ theme }: { theme: Theme }) => ({
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  padding: theme.spacing(2),
}));

const DrawerCustom = (props: DrawerCustomProps): JSX.Element => {
  const { children, size = "md", sx = {}, ...otherProps } = props;
  const styles = {
    "& .MuiDrawer-paper": {
      width: drawerSizeMap[size],
    },
    ...sx,
  };
  return (
    <Drawer data-testid="ds-drawer-custom" {...otherProps} sx={styles}>
      {children}
    </Drawer>
  );
};

export default DrawerCustom;
export { DrawerContent, DrawerCustom, DrawerNavBar };
